import { action } from 'easy-peasy';
import { IActionSetCarePlanMedications } from '../types';

const setCarePlanMedications: IActionSetCarePlanMedications = action((state, payload) => {
  state.items = payload;
});

export default setCarePlanMedications;
